import { render, staticRenderFns } from "./LH04_Redeempoint.vue?vue&type=template&id=0710acee&scoped=true&"
import script from "./LH04_Redeempoint.vue?vue&type=script&lang=js&"
export * from "./LH04_Redeempoint.vue?vue&type=script&lang=js&"
import style0 from "./LH04_Redeempoint.vue?vue&type=style&index=0&id=0710acee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0710acee",
  null
  
)

export default component.exports